import { render, staticRenderFns } from "./loadingComponent.vue?vue&type=template&id=259b84d4"
import script from "./loadingComponent.vue?vue&type=script&lang=js"
export * from "./loadingComponent.vue?vue&type=script&lang=js"
import style0 from "./loadingComponent.vue?vue&type=style&index=0&id=259b84d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports